import {useState, useEffect} from 'react';

// this is a helper variable to store a function to make listening through PM seem async like listening through a match request
let phonemeListeningCompleteCallback = null;
let resolveBlendingPromise = null;



export default function useBlendingTaskPlacementListening({
  currentWordIndex, 
  speech, 
  phrase, 
  graphemeIndexRef=null, 
  onPhonemeComplete = null,
  onAllPhonemesComplete,
  onBlendedWordComplete,
  onWordIndexAdvanced,
  onPhonemeListenStart,
  onBlendedWordListenStart,
  enabled
}) {

  // callback for when we're done listening for the last phoneme. This will resolve the promise we're 
  //  awaiting in onStageChange. For now, this will only happen in tutorMode
  async function listenForPhonemesComplete(){
    if(onPhonemeListenStart){
      onPhonemeListenStart();
    }

    speech.startListening();

    // return a promise. make wordIndexChangeCallback resolve that promise
    return new Promise((resolve, reject) => {
      phonemeListeningCompleteCallback = () => {
        resolve();
        phonemeListeningCompleteCallback = null;
      };
    });
  }

  async function listenForBlendedWordComplete(){
    if(onBlendedWordListenStart){
      onBlendedWordListenStart();
    }

    speech.startListening();

    // return a promise. make wordIndexChangeCallback resolve that promise
    return new Promise((resolve, reject) => {
      resolveBlendingPromise = (success) => {
        resolve(success);
      };
    });
  }

  function blendedWordListeningCompleteCallback(success){
    if(resolveBlendingPromise){
      resolveBlendingPromise(success);
    }
    resolveBlendingPromise = null;
  }

  function onWordIndexChange(){

    const newWordIndex = currentWordIndex;

    // do nothing if the word index change does not make forward progress
    if((graphemeIndexRef && (graphemeIndexRef.current || graphemeIndexRef.current == 0)) && newWordIndex - 1 <= graphemeIndexRef.current){   
      return;
    }

    const phraseLength = phrase.split(" ").length;

    // for this acivity type assume that all but the last "word" of the phrase are phonemes
    //  if we just moved on from the second to last word, that means we just heard the last phoneme
    //  and we are ready to start listening for the blended word. Clear the max listen time timeout
    //  and call phonemeListeningCompleteCallback since we're done listening for phonemes
    if(phonemeListeningCompleteCallback && newWordIndex >= phraseLength - 1){
      phonemeListeningCompleteCallback();
      if(onAllPhonemesComplete){
        onAllPhonemesComplete();
      }

    // if we just moved on from the last word of the phrase, that means we just heard the blended word
    //  in this case we should call blendedWordListeningCompleteCallback will a success flag
    } else if(newWordIndex >= phraseLength && blendedWordListeningCompleteCallback){
      if(blendedWordListeningCompleteCallback){
        blendedWordListeningCompleteCallback(true);
        if(onBlendedWordComplete){
          onBlendedWordComplete();
        }
      }
    } else {
      //TODO: figure out how to deal with grapheme ref. this can't be passed here -- bind it above
      if(onPhonemeComplete){
        onPhonemeComplete(graphemeIndexRef.current); //only restart the timer if we're still listening for the phonemes. this will be started separately for the blended word
      }
    }

    // no matter what, advance the grapheme index, unless we've aleady got to the end of the phrase
    if(newWordIndex <= phraseLength){ 
      if (onWordIndexAdvanced){
        onWordIndexAdvanced(newWordIndex); // the grapheme index is meant to represent the index of the grapheme that was just spoken, not the one the child is currently working on. -1 is the index for the bottom of the slide 
      }
    }
  }

  useEffect(() => {
    if (enabled) {
      onWordIndexChange();
    }
  }, [currentWordIndex]);

  return {
    listenForPhonemesComplete,
    listenForBlendedWordComplete,
    phonemeListeningCompleteCallback,
    blendedWordListeningCompleteCallback,
  }
}